import { z } from 'zod';

/**
 * Utility function to coerce the values of ControlledPercentInput and ControlledCurrencyInput
 * to a number.
 * We do not use z.coerce() because null and '' values are coerced to 0 and that may not be desired.
 * @see https://zod.dev/api#coercion note on using Number() for conversion
 */
export const zodStringOrNumberToNumber = () => z.string().transform(Number).or(z.number());
